<template>

  <v-dialog v-model="dialog" :max-width="resolvedWidth" :persistent="persistent" :fullscreen="fullscreen">

    <v-card class="d-flex flex-column" style="max-height: 90vh;">

      <v-app-bar flat tile :fixed="fullscreen" v-if="title || dismissible" style="flex-shrink: 0;"
                 :color="header_background_color">

        <v-toolbar-title :style="'color :' + header_elements_color" v-if="title">{{ title }}</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-toolbar-items class="d-flex align-center">

          <slot name="top-actions"></slot>

          <v-btn icon :color="header_elements_color" @click="dialog = false" v-if="dismissible">
            <v-icon>mdi-close</v-icon>
          </v-btn>

        </v-toolbar-items>

      </v-app-bar>

      <v-progress-linear
          v-if="showStatusBar"
          :indeterminate="loading_queue.length > 0 || loading"
          :value="100"
          :color="statusBarColor"
          height="3"
          style="flex-shrink: 0;"
      ></v-progress-linear>

      <div :class="{'mt-15': fullscreen}" style="flex: 1; overflow-y: auto; min-height: 0;" class="d-flex flex-column">
        <div :class="content_class" style="flex: 1; display: flex; flex-direction: column;" >

          <slot name="content"

                :onLoading="onLoading"
                :onSaved="onSaved"
                :onLoaded="onLoaded"
                :onSaving="onSaving"
                v-if="value"
          >

          </slot>


        </div>
      </div>



      <div v-if="$slots['bottom-actions']" style="flex-shrink: 0;">

        <v-divider></v-divider>
        <v-card-actions>
          <slot name="bottom-actions"></slot>
        </v-card-actions>

      </div>

    </v-card>

  </v-dialog>

</template>

<script>

export default {

  name: 'PlingDialog',
  props: {

    value: {required: true},
    title: {required: false, type: String},
    dismissible: {required: false, type: Boolean, default: false},
    fullscreen: {required: false, type: Boolean, default: false},
    persistent: {required: false, type: Boolean, default: false},
    padded: {required: false, type: Boolean, default: false},
    nogutter: {required: false, type: Boolean, default: false},
    size: {required: false, type: String, default: 'md'},
    maxWidth: {required: false},
    header_background_color: {required: false, type: String, default: ''},
    header_elements_color: {required: false, type: String, default: ''},
    dirty: {required: false, type: Boolean, default: false},
    loading: {required: false, type: Boolean, default: false},
    showStatusBar: {required: false, type: Boolean, default: false},

  },

  data: function(){

    return {
      dialog: false,



      loading_queue: [],
      saved_queue: []

    }

  },

  computed: {

    resolvedWidth() {
      if (this.maxWidth !== undefined) return this.maxWidth;
      return { sm: 400, md: 600, lg: 900, xl: 1200 }[this.size] ?? 600;
    },

    statusBarColor() {
      if (this.loading_queue.length > 0 || this.loading) return 'warning';
      if (this.dirty) return 'warning';
      if (this.saved_queue.length > 0) return 'success';
      return 'primary';
    },

    content_class: function(){


      let self = this;


      if(self.padded){

        return 'pa-7';

      }


      if(self.nogutter){

        return '';

      }

      return 'fill-height px-3 py-5'

    }

  },

  methods: {


    onSaving: function(element){

      this.onLoading(element);

    },

    onLoading: function(element){

      if(this.loading_queue.indexOf(element) === -1){

        this.loading_queue.push(element);

      }

    },

    onLoaded: function(element){



      if(this.loading_queue.indexOf(element) !== -1){

        this.loading_queue.splice(this.loading_queue.indexOf(element),1);

      }

    },

    onSaved: function(element){


      this.onLoaded(element);

      if(this.saved_queue.indexOf(element) === -1){

        this.saved_queue.push(element);

      }

    }


  },

  beforeMount: function(){

    this.dialog = this.value;

  },

  watch: {

    value: function(newVal){

      this.dialog = newVal;

    },

    dialog: function(newVal){


      this.$emit('input',newVal);

    }

  },


}


</script>
